import React, { useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { DocumentModalSkeleton } from "@/components/skeletons";
import { Button } from "@/components/ui/button";
import { Document, Page } from "react-pdf";

interface DocumentModalProps {
    show?: boolean;
    onHide?: () => void;
    content: any;
}

const DocumentModal = (props: DocumentModalProps) => {
    const [numPages, setNumPages] = React.useState(0);
    const [pdfFile, setPdfFile] = React.useState<any>(props.content);

    useEffect(() => { setPdfFile(props.content); }, [props.content]);

    function onDocumentLoadSuccess({ numPages }: any) { setNumPages(numPages); }

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto">
                {pdfFile ? (
                    <>
                        <DialogHeader>
                            <DialogTitle>{pdfFile ? pdfFile.title : ""}</DialogTitle>
                        </DialogHeader>
                        <div className="all-page-container px-6 py-2">
                            <Document onLoadSuccess={onDocumentLoadSuccess} file={pdfFile ? pdfFile.content : null}>
                                <div>
                                    {Array.from(Array(numPages).keys()).map((index) => (
                                        <Page key={`page_${index}`} pageNumber={index + 1} />
                                    ))}
                                </div>
                            </Document>
                        </div>
                        <DialogFooter>
                            <Button variant="light" onClick={props.onHide}>Cancel</Button>
                        </DialogFooter>
                    </>
                ) : (
                    <DocumentModalSkeleton />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default DocumentModal;
